import { isNova } from '@/config'
import { CoreCsvUploadType } from '@repo/csv'

/**
 * Each line keeps the auto-inject uploads its own Fuze Core is configured to ingest.
 *
 * Nova split the shared `autoInject_inbound_orders` folder in two for the Payment Term CR, and its
 * Core reads the two new folders instead of the old one. Mainline's Core still reads the shared
 * folder. Offering the wrong pair would put files somewhere nothing collects them, so the tiles
 * follow the environment rather than the fold picking a winner.
 */
export const AUTO_INJECT_UPLOAD_TYPES: CoreCsvUploadType[] = isNova
  ? ['auto-inject-pick-and-ship', 'auto-inject-corner-orders', 'auto-inject-rma', 'auto-distro']
  : ['auto-inject', 'auto-inject-delivery-dates', 'auto-inject-rma', 'auto-distro']
